import { DiagnosticsItemStatus } from '@diagnostics/config'
import type { DiagnosticsItemStateRemoteData } from '@diagnostics/services/types'
import { LearnType } from '@shared/config'
import AbstractTrainerState from '@abstract-trainer/models/AbstractTrainerState'
import AppealRequest from '@appeals/models/AppealRequest'

const validate = (data: DiagnosticsItemStateRemoteData) => {
  if (!data) throw new Error('Invalid diagnostics item state data.')
}

export default class DiagnosticsItemState extends AbstractTrainerState {
  type: LearnType.Diagnostic
  status: DiagnosticsItemStatus
  timeLeft: number | null
  attempts: number
  canRequestAppeal: boolean
  appealRequest: AppealRequest | null
  permitted: boolean
  permittedByDate: boolean
  diagnosticsItemDuration: number

  constructor(data: DiagnosticsItemStateRemoteData) {
    super()
    validate(data)

    this.type = LearnType.Diagnostic

    this.status = data.status ?? DiagnosticsItemStatus.InProgress
    this.timeLeft = data.time_left ?? null
    this.attempts = data.attempts ?? 0
    this.canRequestAppeal = !!data.can_request_appeal
    this.appealRequest = data.appeal ? new AppealRequest(data.appeal) : null
    this.permitted = data.permitted ?? true
    this.permittedByDate = data.permitted_date ?? true
    this.diagnosticsItemDuration = data.diagnostic_duration ?? 0
  }

  get isPermitted() {
    return this.permitted && this.permittedByDate
  }

  get isFinished() {
    return this.status === DiagnosticsItemStatus.Finished
  }

  get isPending() {
    return this.status === DiagnosticsItemStatus.Pending
  }

  get isInProgress() {
    return this.status === DiagnosticsItemStatus.InProgress
  }
}
